import React from "react";
import {
    Box,
    Grid,
    Button,
    TextField,
    MenuItem,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import {withStyles} from "@mui/styles";
import {schemeOptions} from "../../constants/schemes";
import {dialogTitleStyles} from "../../constants/styles";

class DialogSectionForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            item: null,
            isOpen: false,
            onSubmit: null,
        };
    }

    open = ({item, onSubmit}) => {
        this.setState({
            item: item || {
                title: "",
                position_from: "",
                position_to: "",
                scheme: "general",
            },
            isOpen: true,
            onSubmit,
        });
    }

    close = () => {
        this.setState({
            item: null,
            isOpen: false,
            onSubmit: null,
        });
    }

    submitItem = () => {
        this.state.onSubmit(this.state.item);
    }

    changeItem = ({target}) => {
        const {name, value} = target;
        let item = {...this.state.item};
        item[name] = value;
        this.setState({item});
    }

    render() {
        const {item, isOpen} = this.state;
        const {classes} = this.props;

        if (!isOpen) return null;

        const isEdit = Boolean(item?.id);

        return (
            <Dialog
                fullWidth
                open={isOpen}
                maxWidth="sm"
                onClose={this.close}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Typography variant="h3">
                        {isEdit ? "Редактирование раздела" : "Создание раздела"}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box pt={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    value={item.title}
                                    name="title"
                                    size="small"
                                    label="Название раздела"
                                    placeholder="Например: Марка, Модель"
                                    fullWidth
                                    onChange={this.changeItem}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    value={item.position_from}
                                    name="position_from"
                                    size="small"
                                    label="Позиция от (1-17)"
                                    type="number"
                                    inputProps={{min: 1, max: 17}}
                                    fullWidth
                                    onChange={this.changeItem}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    value={item.position_to}
                                    name="position_to"
                                    size="small"
                                    label="Позиция до (1-17)"
                                    type="number"
                                    inputProps={{min: 1, max: 17}}
                                    fullWidth
                                    onChange={this.changeItem}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={item.scheme}
                                    name="scheme"
                                    size="small"
                                    label="Схема"
                                    select
                                    fullWidth
                                    onChange={this.changeItem}
                                >
                                    {schemeOptions.map((opt) => (
                                        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid justifyContent="flex-end" container px={2} spacing={1}>
                        <Grid item>
                            <Button size="small" variant="outlined" onClick={this.close}>Закрыть</Button>
                        </Grid>
                        <Grid item>
                            <Button
                                size="small"
                                variant="contained"
                                disabled={!item.title || !item.position_from || !item.position_to}
                                onClick={this.submitItem}
                            >Сохранить</Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        );
    }
}

DialogSectionForm = withStyles(dialogTitleStyles)(DialogSectionForm);

export default DialogSectionForm;
